import { Signup } from 'config/constants'
import { useState } from 'react'
import { Box, Button, Stack, Title, Text } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

import Price from 'components/business/ProductsModal/Price'
import { ProductCode } from 'config/constants/products'
import { PriceInterval, Product } from 'types/domain'
import { formatNumberToThousands } from 'utils'

export interface ProductIntroProps {
  product: Product
  priceInterval: PriceInterval
  currentCode?: ProductCode
  disablePurchase?: boolean
  feature?: string
}

const ProductIntro = ({ product, priceInterval, feature }: ProductIntroProps) => {
  const { t } = useTranslation('product')
  const router = useRouter()
  const { code, name, prices } = product
  const price = prices.find((price) => price.interval === priceInterval)
  const [loading, setLoading] = useState(false)

  const isPaid = code !== ProductCode.Free

  const handleClick = () => {
    setLoading(true)
    jumpToSignUp()
  }

  const jumpToSignUp = () => {
    const query = isPaid ? { productCode: code } : {}
    router.push({
      pathname: Signup,
      query,
    })
  }

  return (
    <Box
      w={226}
      h={180}
      px={16}
      sx={(theme) => ({
        background: isPaid ? '#F6F8F9' : 'white',
        border: `1px solid ${isPaid ? 'transparent' : '#E3E5E8'}`,
        borderRadius: 8,
      })}
    >
      <Stack py="xl" h={180} ta="center" spacing={4}>
        <Title order={3} lh="28px">
          {name}
        </Title>
        <Stack mt="auto" spacing={24}>
          {price ? (
            <>
              <Price price={price} />
              <Button fullWidth size="sm" disabled={loading} onClick={handleClick}>
                {t('purchaseNow')}
              </Button>
            </>
          ) : (
            <>
              <Text fz={24} fw={600} lh="30px" ta="center">
                {formatNumberToThousands(0 / 100, {
                  style: 'currency',
                  currency: 'CNY',
                  point: 0,
                  currencyDisplay: 'narrowSymbol',
                })}
              </Text>
              <Button variant="default" fullWidth size="sm" onClick={jumpToSignUp}>
                免费使用
              </Button>
            </>
          )}
        </Stack>
      </Stack>
    </Box>
  )
}

export default ProductIntro
